import { isMobile } from '../utils/device';

export default () => {
  const headerElement = document.querySelector('#main-header');
  if (!headerElement) return;

  const isStickyHeaderEnabled = headerElement.classList.contains('header--sticky')

  const hideHeaderScrollOffset = headerElement.getBoundingClientRect().height;
  const showHeaderScrollOffset = 0;
  const topOffset = 15;
  let lastScrollY = 0;
  let startScrollingDownY = 0;
  let startScrollingUpY = 0;
  let isHidden = false;
  let isLocked = false;

  function hide() {
    if (isHidden || isLocked) return;
    if (window.scrollY < hideHeaderScrollOffset) {
      window.scrollTo(0, hideHeaderScrollOffset);
    }

    if (isStickyHeaderEnabled)  {
      isHidden = true;
      if (!headerElement.classList.contains('header--menu-active')){
        headerElement.classList.add('header--hidden');
        document.body.classList.add('header-is-hidden');
      }
    }

    window.dispatchEvent(new Event('hideheader'));
    setTimeout(() => {
      updateHeaderHeightStyles(0);
    }, 200);
  }

  function show() {
    if (!isHidden) return;
    if (isStickyHeaderEnabled) {
      isHidden = false;
      headerElement.classList.remove('header--hidden');
      document.body.classList.remove('header-is-hidden');
    }
    window.dispatchEvent(new Event('showheader'));
    updateHeaderHeightStyles(headerElement.getBoundingClientRect().height);
  }

  function lock() {
    isLocked = true;
    show();
  }

  function unlock() {
    isLocked = false;
  }

  function scrollHandler() {
    const currentScrollY = window.scrollY;
    const isScrollingDown = currentScrollY > lastScrollY;
    const isScrollingUp = !isScrollingDown;

    if (isScrollingUp) {
      startScrollingDownY = currentScrollY;
    }

    if (isScrollingDown) {
      startScrollingUpY = currentScrollY;
    }

    if (isHidden && isScrollingUp && currentScrollY < startScrollingUpY - showHeaderScrollOffset) {
      show();
    }

    if (!isLocked && !isHidden && isScrollingDown && currentScrollY > startScrollingDownY + hideHeaderScrollOffset) {
      hide();
    }

    lastScrollY = currentScrollY;
  }

  document.addEventListener('scroll', scrollHandler.bind(this));

  const searchInputElement = headerElement.querySelector('#search-text');
  if (searchInputElement) {
    searchInputElement.addEventListener('focus', lock.bind(this));
    searchInputElement.addEventListener('blur', unlock.bind(this));

    if (isMobile()) {
      window.addEventListener('touchmove', () => {
        if (!isHidden) {
          if (searchInputElement) {
            searchInputElement.dispatchEvent(new Event('cancelsearch'));
            searchInputElement.blur();
          }
        }
      })
    }
  }

  if (isMobile()) {
    window.addEventListener('requesthideheader', hide.bind(this));
    window.addEventListener('requestshowheader', show.bind(this));
  }

  function updateHeaderHeightStyles(height = 0) {
    document.documentElement.style.setProperty('--header-height', `${height}px`);
  }

  updateHeaderHeightStyles(headerElement.getBoundingClientRect().height);
  document.documentElement.style.setProperty('--sticky-top-offset', `calc(var(--header-height, 0px) + var(--top-offset, ${topOffset}px))`);

  window.addEventListener('resize', () => {
    updateHeaderHeightStyles(headerElement.getBoundingClientRect().height);
  });
}